import React, { useEffect, useState } from "react";

const Herosection = () => {
  const [animate, setAnimate] = useState(false);

  // Trigger animation on mount
  useEffect(() => {
    setAnimate(true);
  }, []);
  
  return (
    <section className="w-full bg-gray-50 py-16 px-4 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center gap-8 md:gap-16">
        
        {/* Left Text */}
        <div
          className={`flex-1 transition-all duration-1000 ease-out
            ${animate ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Leading Smartphones Distributor in Ghaziabad: Deals You Can’t Miss!
          </h2>
          <p className="text-gray-700 text-base md:text-lg mb-4">
            Welcome to <span className="font-semibold">PC Enterprises</span>, the best smartphone distributor in Ghaziabad! Here, you can find top phones from famous brand like Oppo.
          </p>
          <p className="text-gray-700 text-base md:text-lg">
            At PC Enterprises, we have lots of latest phone models, good prices, and make sure you have a great time shopping. Come to our store, see all the phones, get special deals, and talk to an expert to help you pick the best phone. You can always trust PC Enterprises to help you!
          </p>
        </div>

        {/* Right Image */}
        <div
          className={`flex-1 transition-all duration-1000 ease-out
            ${animate ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}
        >
          <img
            src="https://media.istockphoto.com/id/2058167163/photo/oppo-retail-store-chinese-electronics-company.jpg?s=612x612&w=0&k=20&c=lwibC2Dk6dYQRV-p_gSnwIMqESnyZ31jAFfP4RZY-ag="
            alt="PC Enterprises"
            className="w-full rounded-xl shadow-lg object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default Herosection;
